import {combineReducers} from "redux";
import sendFax from './Faxes/SendFax'

// Delete Fax Modal visible state
const defaultDeleteFaxShow = false;
const deleteFaxShow = (state = defaultDeleteFaxShow, action) => {
    switch (action.type) {
        case 'DELETE_FAX_SHOW':
            return true;
        case 'GET_FAXES':
        case 'DELETE_FAX_SUCCESS':
        case 'DELETE_FAX_CANCEL':
            return false;
        default:
            return !!state;
    }
};

const defaultDeleteFaxID = null;
const deleteFaxID = (state= defaultDeleteFaxID, action) => {
    switch (action.type) {
        case 'DELETE_FAX_SHOW':
            return action.id;
        case 'DELETE_FAX_SUCCESS':
        case 'DELETE_FAX_CANCEL':
            return null;
        default:
            return state;
    }
};

const defaultSendFaxShow = false;
const sendFaxShow = (state = defaultSendFaxShow, action) => {
    switch (action.type) {
        case 'SEND_FAX_SHOW':
            return true;
        case 'SEND_FAX':
        case 'SEND_FAX_SUCCESS':
        case 'SEND_FAX_CANCEL':
            return false;
        default:
            return !!state;
    }
};

// Incoming faxes loading state
const defaultLoadingIncomingFaxes = false;
const loadingIncomingFaxes = (state = defaultLoadingIncomingFaxes, action) => {
    switch (action.type) {
        case 'INCOMING_FAXES':
            return true;
        case 'INCOMING_FAXES_SUCCESS':
        case 'INCOMING_FAXES_ERROR':
            return false;
        default:
            return state;
    }
};


// Outgoing faxes loading state
const defaultLoadingOutgoingFaxes = false;
const loadingOutgoingFaxes = (state = defaultLoadingOutgoingFaxes, action) => {
    switch (action.type) {
        case 'OUTGOING_FAXES':
            return true;
        case 'OUTGOING_FAXES_SUCCESS':
        case 'OUTGOING_FAXES_ERROR':
            return false;
        default:
            return state;
    }
};

const defaultActiveFaxTab = 'outgoing';
const activeFaxTab = (state = defaultActiveFaxTab, action) => {
    switch (action.type) {
        case 'SET_ACTIVE_FAX_TAB':
            return action.tab;
        default: return state;
    }
};

export default combineReducers({
    deleteFaxShow,
    loadingIncomingFaxes,
    loadingOutgoingFaxes,
    deleteFaxID,
    sendFaxShow,
    sendFax,
    activeFaxTab
});